import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { interval } from 'rxjs';
import { RedactReplyServiceService } from '../service/redact-reply-service.service';
import { AppError } from '../common/class/app-error';
import { SubSink } from '../../../node_modules/subsink';
import { HttpClient } from '@angular/common/http';
import { Redact, RedactReply, IRedactHF, IEmailVefifyHF, EmailVefify, IBrandDetailsHF, BrandDetails, ICountryCodeDetails, CountryCodeDetails } from '../class/redact';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { timer, Subscription } from "rxjs";
import { AI_AutoLock_Access_Check } from '../service/AutoLock_Access_Check/AI_AutoLock_Access_Check';
import { SendAccessControlNoticeRequestv2 } from '../class/SendAccessControlNoticeRequestModel';
import { Location } from '@angular/common';
import { AppConfigService } from '../app-config.service';
import { AccessDecision } from '../class/AutoLockAccess';
import { AccessDecisionService } from '../service/AccessDecisionService';
import { Subject } from 'rxjs';
import { SessionStateService } from '../service/session-state.service';
import { AutolockSessionStateService } from '../service/Autolock-session-state.service';
import { CryptoService } from '../service/CryptoService';
import { GuidGenerator } from '../common/class/guid-generator';
import { MailContextRequest, MailContextData } from 'src/app/class/MailContextRequest ';

@Component({
  selector: 'app-text-viewv1',
  templateUrl: './text-viewv1.component.html',
  styleUrls: ['./text-viewv1.component.scss']
})
export class TextViewv1Component implements OnInit {

  logoId: string;
  isVerified = false;
  isSMSOptionEnabled: boolean = false;
  destShortURL: string;
  emailId: string;
  phoneNumber: string;
  countryCode: string;

  public redact = new Redact;
  public emailVerfication = new EmailVefify;
  public brandDetails = new BrandDetails;
  public countryCodeDetails = new CountryCodeDetails;
  private subs = new SubSink();
  loginForm: FormGroup;
  loginFormSMS: FormGroup;
  public copied = false;
  showLogo: boolean = true;
  emailDispatchOption: number;
  companyLogoURL: string = "";
  countDown: Subscription;
  confidentialityStatement: string;
  tick = 1000;
  subscription: Subscription;
  isAutoLock_AccessDenied: boolean;
  accessDeniedText: string;
  isDisappearInk: boolean;
  contactSenderText: string;
  productLine: string;
  private unsubscribe$ = new Subject<void>();
  viewTextRefUrl: string;
  featureType: string;
  themeValue: boolean;
  copyImages: string[] = [];
  ClipboardItem: any;
  ActiveTabsKey: any;
  detectionKey: any;
  OpenActiveTabsKey: any;
  OpendetectionKey: any;
  AutolockActiveTabsKey: any;
  AutolockDetectionKey: any;
  crypto: CryptoService;
  deviceLogId: string = GuidGenerator.standard();
  IsDeviceFingerprintSettingEnabled: boolean = false;
  loading = true;
  brandingLoaded = false;
  destinationLoaded = false;
  public mailContextData!: MailContextData;

  constructor(private formBuilder: FormBuilder, private user: RedactReplyServiceService, private AI_Autolock_user: AI_AutoLock_Access_Check, private http: HttpClient, private router: Router, private route: ActivatedRoute
    , private translate: TranslateService, private location: Location, private accessDecisionService: AccessDecisionService, private sanitizer: DomSanitizer,
    private config: AppConfigService, private sessionState: SessionStateService, private AutolockSessionState: AutolockSessionStateService) {
    this.viewTextRefUrl = this.config.viewTextRefUrl;
    this.crypto = new CryptoService();
    this.route.params.subscribe(params => {
      // const shortURL: string = params.shortURL;
      this.destShortURL = params.shortURL;

    });
    this.productLine = this.config.productLine;
  }
  public conditionvalue: number = 0;
  emailPattern = "^[a-zA-Z0-9.!#_%'&^$?\\-/+=]*[a-zA-Z0-9.!#_%'&^$?\\-/+=]+@[a-zA-Z\\u0080-\\uFFFF0-9_-]+\\.[a-zA-Z]{2,4}(?:\.[a-zA-Z]{2})?$";
  phoneNumberPattern = "^[0-9+\\- ]+$";

  ngOnInit() {
    this.loading = false;
    this.brandingLoaded = false;
    this.destinationLoaded = false;
    this.featureType = 'Redact';
    const request: MailContextRequest = {
      shortUrl: this.destShortURL,
      feature: this.featureType,
       productLine: this.config.productLine,
      deviceLogId: this.deviceLogId
    };

    this.AI_Autolock_user.getMailContext(request).subscribe({
      next: (response) => {

        if (!response || !response.success || !response.resultContent) {
          return;
        }

        // Decrypt response
        const encryptedResult = response.resultContent;

        const base64Value = this.crypto.decryptQueryString(
          encryptedResult,
          this.config.preSetEncryptPwdKey,
          this.config.preSetEncryptPwdIVector
        );

        this.mailContextData = JSON.parse(
          atob(base64Value)
        ) as MailContextData;

        // Branding
        this.getBrandingDetails();

        // Reference URL
        this.viewTextRefUrl = this.viewTextRefUrl.replace(
          '{shortURL}',
          this.destShortURL
        );

        // Language
        const language =
          this.mailContextData.DestinationDetails.MessageLanguage || 'en-us';

        this.translate.use(language);
        localStorage.setItem('Langauge', language);

        // Device Fingerprint
        this.IsDeviceFingerprintSettingEnabled =
          this.mailContextData.DestinationDetails.DeviceFingerprintSetting || false;

        // AutoLock validation
        if (
          !this.mailContextData.PasswordVerified &&
          this.mailContextData.DestinationDetails.RequestStatus != 2
        ) {

          if (this.mailContextData.Lock) {

            const accessControlNoticeRequest: SendAccessControlNoticeRequestv2 = {
              lockId: this.mailContextData.LockId,
              shortUrl: this.mailContextData.ShortUrl,
              feature: 'RMail - Redact'
            };

            // Removal Request Enabled
            if (
              this.mailContextData.EnableRemovalRequest !== null &&
              this.mailContextData.EnableRemovalRequest
            ) {

              (async () => {
                await this.triggerDetectionAndNotifyAccess(
                  this.destShortURL,
                  this.mailContextData.LockId || '',
                  accessControlNoticeRequest,
                  this.mailContextData.IpAddress || ''
                );
              })();

              if (
                this.mailContextData.DestinationDetails != null &&
                this.mailContextData.DestinationDetails.RequestStatus != 2
              ) {

                const accessDecision: AccessDecision = {
                  Id: this.mailContextData.DestinationDetails.MessageId,
                  Feature: this.featureType,
                  Key: this.destShortURL,
                  Count:
                    this.mailContextData.DestinationDetails.RequestsCount != null
                      ? this.mailContextData.DestinationDetails.RequestsCount
                      : 0,
                  Status:
                    this.mailContextData.DestinationDetails.RequestStatus != null
                      ? this.mailContextData.DestinationDetails.RequestStatus
                      : 0,
                  Lang:
                    this.mailContextData.DestinationDetails.MessageLanguage,
                  RefUrl: this.viewTextRefUrl,
                  Theme: null,
                  Source: null,
                  hashedLockId: this.mailContextData.LockId,
                  EMailDispatchOption: this.mailContextData.DestinationDetails.EMailDispatchOption,
                  PhoneNumber: this.mailContextData.DestinationDetails.PhoneNumber,
                  DestinationName: this.mailContextData.DestinationDetails.DestinationName,
                  SenderAddress: this.mailContextData.DestinationDetails.SenderAddress,
                  MessageSubject: this.mailContextData.DestinationDetails.MessageSubject,
                  DestinationAddress: this.mailContextData.DestinationDetails.DestinationAddress
                };

                this.accessDecisionService.setAccessDecision(
                  accessDecision
                );

                this.router.navigate([
                  '/requestaccess/RD'
                ]);

                return;
              }
            }

            // Removal Request Disabled
            else {

              (async () => {
                await this.triggerDetectionAndNotifyAccess(
                  this.destShortURL,
                  this.mailContextData.LockId || '',
                  accessControlNoticeRequest,
                  this.mailContextData.IpAddress || ''
                );
              })();

              this.isAutoLock_AccessDenied = true;
              this.accessDeniedText = 'Access Denied';
              this.contactSenderText =
                'Please contact the sender for further information.';
              this.isDisappearInk = false;

              this.location.go(
                '/accessdenied/' +
                this.destShortURL +
                '/RD'
              );

              return;
            }
          }

          // Access Allowed
          else {

            console.log('Access is allowed');

            (async () => {
              await this.triggerDetectionAndNotifyAccess(
                this.destShortURL,
                '',
                null,
                this.mailContextData.IpAddress || ''
              );
            })();

            this.isAutoLock_AccessDenied = false;
            this.accessDeniedText = '';
            this.contactSenderText = '';
            this.isDisappearInk = false;

            this.getCountryDialCodeList();

            this.loginForm = this.formBuilder.group({
              emailId: [
                null,
                [
                  Validators.required,
                  Validators.pattern(this.emailPattern)
                ]
              ]
            });

            this.loginFormSMS = this.formBuilder.group({
              phoneNumber: [
                null,
                [
                  Validators.required,
                  Validators.pattern(this.phoneNumberPattern)
                ]
              ],

              countryDialCode: [
                null,
                [Validators.required]
              ]
            });
          }

          // AutoLock feature disabled
          if (!this.mailContextData.AutoLockEnabled) {

            console.log(
              'Autolock feature is not enabled'
            );

            (async () => {
              await this.triggerDetectionAndNotifyAccess(
                this.destShortURL,
                '',
                null,
                this.mailContextData.IpAddress || ''
              );
            })();

            this.isAutoLock_AccessDenied = false;
            this.accessDeniedText = '';
            this.contactSenderText = '';
            this.isDisappearInk = false;

            this.getCountryDialCodeList();

            this.loginForm = this.formBuilder.group({
              emailId: [
                null,
                [
                  Validators.required,
                  Validators.pattern(this.emailPattern)
                ]
              ]
            });

            this.loginFormSMS = this.formBuilder.group({
              phoneNumber: [
                null,
                [
                  Validators.required,
                  Validators.pattern(this.phoneNumberPattern)
                ]
              ],

              countryDialCode: [
                null,
                [Validators.required]
              ]
            });
          }
        }

        // Passcode approved / Request already approved
        else {

          (async () => {
            await this.triggerDetectionAndNotifyAccess(
              this.destShortURL,
              '',
              null,
              this.mailContextData.IpAddress || ''
            );
          })();

          this.isAutoLock_AccessDenied = false;
          this.accessDeniedText = '';
          this.contactSenderText = '';
          this.isDisappearInk = false;

          this.getCountryDialCodeList();

          this.loginForm = this.formBuilder.group({
            emailId: [
              null,
              [
                Validators.required,
                Validators.pattern(this.emailPattern)
              ]
            ]
          });

          this.loginFormSMS = this.formBuilder.group({
            phoneNumber: [
              null,
              [
                Validators.required,
                Validators.pattern(this.phoneNumberPattern)
              ]
            ],

            countryDialCode: [
              null,
              [Validators.required]
            ]
          });
        }
      },

      error: (error) => {
        console.error(
          'Error during mail context request:',
          error
        );
      }
    });
  }


  async triggerDetectionAndNotifyAccess(
    ShortURL: string,
    LockId: string,
    request: SendAccessControlNoticeRequestv2 | null,
    ipAddress: string
  ): Promise<void> {
    //opendetection
    this.ActiveTabsKey = `rd_${this.destShortURL}_${ipAddress}`;
    this.detectionKey = `RDODT_${this.destShortURL}_${ipAddress}`;
    //autolock opendetection
    this.OpenActiveTabsKey = `ord_${this.destShortURL}_${ipAddress}`;
    this.OpendetectionKey = `ORDODT_${this.destShortURL}_${ipAddress}`;
    //autolock
    this.AutolockActiveTabsKey = `Ard_${this.destShortURL}`;
    this.AutolockDetectionKey = `ARDODT_${this.destShortURL}`;
    //without autolock enabled
    if (!LockId && !request) {
      this.sessionState.setKeys(this.detectionKey, this.ActiveTabsKey);
      if (this.sessionState.isFirstVisit()) {
        this.sessionState.markVisited();
        await this.triggerOpenDetection(ShortURL);
        if (this.IsDeviceFingerprintSettingEnabled) {
          await this.saveFingerprintDetails();
        }

      } else {
        console.log('Open detection already triggered or new tab — skipping.');
      }
    }
    //autolock enabled
    if (LockId && request) {
      this.sessionState.setKeys(this.OpendetectionKey, this.OpenActiveTabsKey);

      if (this.sessionState.isFirstVisit()) {
        this.sessionState.markVisited();
        const finalShortURL = `${ShortURL}@${LockId}`;
        await this.triggerOpenDetection(finalShortURL);
        if (this.IsDeviceFingerprintSettingEnabled) {
          await this.saveFingerprintDetails();
        }

      } else {
        console.log('Open detection already triggered or new tab — skipping.');
      }
      this.AutolockSessionState.setKeys(this.AutolockActiveTabsKey, this.AutolockDetectionKey);
      if (this.AutolockSessionState.isFirstVisit()) {
        this.AutolockSessionState.markVisited();
        await this.sendAccessControlNotice(request);

      } else {
        console.log('sendAccessControlNotice already triggered or new tab — skipping.');
      }
    }
  }
  async triggerOpenDetection(id: string): Promise<void> {

    try {
      if (!this.IsDeviceFingerprintSettingEnabled) {
        this.deviceLogId = "";
      }
      const success = await this.AI_Autolock_user
        .triggerOpenDetection(id, "Redact", this.deviceLogId)
        .toPromise();

      if (success) {
        console.log('Open detection triggered successfully');
      }
    }
    catch (error) {
      console.error('Error triggering open detection:', error);
    }
  }
  async saveFingerprintDetails(): Promise<void> {

    try {
      const encryptedFP = await (window as any).collect();
      const success = await this.AI_Autolock_user.saveFingerprintDetails(this.deviceLogId, encryptedFP)
        .toPromise();

      if (success) {

      }
    }
    catch (error) {

    }
  }
  async sendAccessControlNotice(request: SendAccessControlNoticeRequestv2): Promise<void> {
    try {
      const response = await this.AI_Autolock_user
        .sendAccessControlNoticeV2(request)
        .toPromise();

      if (response && response.isSuccess) {
        console.log('AccessControlNotice sent Successfully');
      } else {
        console.log('AccessControlNotice Failed');
      }
    } catch (error) {
      console.error('Error sending access control notice:', error);
    }
  }

  getBrandingDetails() {
    this.subs.sink = this.user.postUserInformation(this.destShortURL, "RD")
      .subscribe(
        resp => {

          if (!(resp instanceof AppError)) {

            const response = resp as IBrandDetailsHF;
            this.brandDetails = response.ResultContent;

            this.themeValue = this.brandDetails.Theme != 2;

            localStorage.setItem('themeValue', JSON.stringify(this.themeValue));

            this.emailDispatchOption = this.brandDetails.EMailDispatchOption;
            this.isSMSOptionEnabled = this.emailDispatchOption == 2;

            if (this.brandDetails.LogoSrc) {
              this.showLogo = true;
              this.companyLogoURL = this.brandDetails.LogoSrc;
            } else {
              this.showLogo = false;
            }
          }

          this.brandingLoaded = true;
          this.checkPageReady();

        },
        () => {
          this.brandingLoaded = true;
          this.checkPageReady();
        });
  }
  EmailVerification(emailID: string, phoneNumber: string, countryDialCode: string) {

    this.subs.sink = this.user.postUserVerification(this.destShortURL, emailID, phoneNumber, countryDialCode, "RD")
      .subscribe(resp => {
        if (!(resp instanceof AppError)) {
          const response = resp as IEmailVefifyHF;
          const result = response.ResultContent;
          this.emailVerfication = result;
          if (this.emailVerfication.Verified.toString() == "true") {
            this.getRedactTextView();

            this.countDown = timer(0, this.tick)
              .subscribe(() => --this.redact.TimeAllowed);

            this.subs.sink = this.user.apiRedactTextViewDuration(this.logoId)
              .subscribe();

            this.isVerified = true;
          }
          else {
            this.validEmail = false;
            this.validNumber = false;
          }

        }
      });

  }
  getRedactTextView() {

    this.subs.sink = this.user.postRedactTextView(this.destShortURL)
      .subscribe(resp => {
        if (!(resp instanceof AppError)) {
          const response = resp as IRedactHF;
          const result = response.ResultContent;
          this.redact = result;
          localStorage.setItem('redact', JSON.stringify(this.redact));

          if (this.redact.LogoSrc == null || this.redact.LogoSrc == "") {
            this.showLogo = false;
          }
          else {
            this.showLogo = true;
            this.companyLogoURL = this.redact.LogoSrc;
          }
          //this.redact.TimeAllowed=100;
          this.confidentialityStatement = this.redact.ConfidentialityStatement;
          const source = interval(this.redact.TimeAllowed * 1000);
          this.redact.resultContents;
          this.subscription = source.subscribe(val => this.redirectToTimeRemaining());

          let count: number = 1;
          for (var x in this.redact.resultContents) {
            let objredact: RedactReply;

            objredact = this.redact.resultContents[x];
            //   console.log(objredact.HtmlText.toString().replace("<o:p></o:p>",));
            this.copyText = this.copyText.concat("Redacted Text ");
            this.copyText = this.copyText.concat(count.toString());
            this.copyText = this.copyText.concat(" :");
            this.copyText = this.copyText.concat('\n');
            this.copyText = this.copyText.concat(objredact.Text.toString().split("<br/>").join("\n"));
            this.copyText = this.copyText.concat('\n');
            this.copyText = this.copyText.concat('\n');
            count = count + 1;

          }
          this.translate.use(this.redact.Language);
          localStorage.setItem('Langauge', this.redact.Language);
          this.logoId = this.redact.LogId;
          if ((this.redact.ViewsLeft == "0") || (this.redact.IsRedactExpired == true)) {
            this.subscription.unsubscribe()
            // setTimeout(()=>  this.subscription.unsubscribe(), 2000);
            this.router.navigate(['viewRemaining'], { skipLocationChange: true });
          }
        }
      });

  }
  getCountryDialCodeList() {
    this.subs.sink = this.user.getCountryDialCodeList()
      .subscribe(resp => {
        if (!(resp instanceof AppError)) {
          const response = resp as ICountryCodeDetails;
          // const result = response.ResultContent;
          this.countryCodeDetails = response;
        }
      })

  }

  redirectToTimeRemaining() {
    // setTimeout(()=>  this.subscription.unsubscribe(), 2000);
    this.router.navigate(['timeRemaining'], { skipLocationChange: true });
  }
  validEmail: boolean = true;
  validNumber: boolean = true;
  public copyText: string = "";
  verifyEmail(form: FormGroup) {
    if (this.loginForm.invalid) {

      if (this.loginForm.controls.emailId.errors)
        this.validEmail = false;
      return;
    }
    this.validEmail = true;
    let email = this.loginForm.controls.emailId.value;
    let phoneNumber = null;
    let countryDialCode = null;
    this.EmailVerification(email.toString(), phoneNumber, countryDialCode);

  }
  verifyNumber(form: FormGroup) {
    if (this.loginFormSMS.invalid) {

      if (this.loginFormSMS.controls.phoneNumber.errors || this.loginFormSMS.controls.countryDialCode.errors) {
        this.validNumber = false;
      }
      return;
    }

    this.validNumber = true;
    let email = null;
    let phoneNumber = this.loginFormSMS.controls.phoneNumber.value;
    let countryDialCode = this.loginFormSMS.controls.countryDialCode.value;
    this.EmailVerification(email, phoneNumber.toString(), countryDialCode.toString());

  }


  async copyMessage() {
    try {

      let htmlContent = '';

      for (let x in this.redact.resultContents) {
        if (this.redact.resultContents.hasOwnProperty(x)) {
          let index = parseInt(x, 10);
          let content = this.redact.resultContents[x];
          htmlContent += `<p><strong>Protected Message ${index + 1}:</strong></p>`;
          htmlContent += content.HtmlText;
        }
      }

      let plainText = this.copyText;
      let currentImageIndex = 0;


      // Create clipboard items
      const clipboardItems = [];
      const htmlBlob = new Blob([htmlContent], { type: 'text/html' });
      const textBlob = new Blob([plainText], { type: 'text/plain' });

      // Add both formats to clipboard
      clipboardItems.push(
        new (window as any).ClipboardItem({
          'text/html': htmlBlob,
          'text/plain': textBlob
        })
      );

      // Write to clipboard
      await (navigator.clipboard as any).write(clipboardItems);
      console.log('All content copied to clipboard successfully');
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 3000);

    } catch (err) {
      console.error('Failed to copy content: ', err);

      // Fallback 1: Try copying just text
      try {
        await navigator.clipboard.writeText(this.copyText);
        console.log('Text copied successfully (fallback)');
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 3000);
      } catch (textErr) {
        console.error('Failed to copy text: ', textErr);
      }

      // Fallback 2: Provide image downloads
      this.copyImages.forEach((img, index) => {
        const link = document.createElement('a');
        link.href = img;
        link.download = `image_${index + 1}.png`;
        link.click();
        console.log(`Image ${index + 1} download triggered`);
      });
    }
  }
  private checkPageReady(): void {
    if (this.brandingLoaded && this.destinationLoaded) {
      setTimeout(() => {
        this.loading = false;
      }, 5000); // Test only

    }
  }
  sanitizeHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngOnDestroy(): void {
    // Emit a value to complete all subscriptions
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
